export default "__VITE_ASSET__9cb4d73e__"